import { createPortal } from 'react-dom';

export function StudioOptionsFullViewTrigger({
  onClick,
  active = false,
  disabled = false,
  label = 'Open full view',
  className = '',
}) {
  return (
    <button
      type="button"
      className={`studio-options-fullview-trigger${active ? ' is-active' : ''}${className ? ` ${className}` : ''}`}
      onClick={onClick}
      disabled={disabled}
      aria-label={label}
      title={label}
      aria-pressed={active}
    >
      <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" focusable="false">
        <path
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          d="M4 8V4h4M20 8V4h-4M4 16v4h4M20 16v4h-4M8 4H6a2 2 0 0 0-2 2v2M16 4h2a2 2 0 0 1 2 2v2M8 20H6a2 2 0 0 1-2-2v-2M16 20h2a2 2 0 0 0 2-2v-2"
        />
      </svg>
    </button>
  );
}

export function StudioOptionsFullViewModal({ open, title, onClose, children }) {
  if (!open || typeof document === 'undefined') return null;

  return createPortal(
    <div
      className="studio-options-fullview-modal"
      role="presentation"
      onClick={onClose}
      onKeyDown={(e) => {
        if (e.key === 'Escape') onClose();
      }}
    >
      <div
        className="studio-options-fullview-modal__sheet"
        role="dialog"
        aria-modal="true"
        aria-label={title || 'Options'}
        onClick={(e) => e.stopPropagation()}
      >
        <header className="studio-options-fullview-modal__head">
          <h3 className="studio-options-fullview-modal__title">{title}</h3>
          <StudioOptionsFullViewTrigger
            active
            label="Close full view"
            onClick={onClose}
            className="studio-options-fullview-trigger--close"
          />
        </header>
        <div className="studio-options-fullview-modal__body">{children}</div>
      </div>
    </div>,
    document.body,
  );
}

export function StudioLookPickerSubTabs({
  tabs,
  activeId,
  onChange,
  disabled = false,
  className = 'studio-look-picker-subtabs',
  trailing = null,
}) {
  return (
    <div className={`${className}${trailing ? ' has-trailing' : ''}`}>
      <div className="studio-look-picker-subtabs__row" role="tablist">
        {tabs.map((t) => (
          <button
            key={t.id}
            type="button"
            role="tab"
            aria-selected={activeId === t.id}
            className={`studio-look-picker-subtabs__btn${activeId === t.id ? ' is-active' : ''}`}
            disabled={disabled}
            onClick={() => onChange(t.id)}
          >
            {t.label}
          </button>
        ))}
      </div>
      {trailing ? <div className="studio-look-picker-subtabs__trailing">{trailing}</div> : null}
    </div>
  );
}
